import { connect } from 'react-redux'
import { compose, withStateHandlers, withHandlers } from 'recompose'
import { createPasswordReset } from './actions'
import { isSendingIntructions } from './selectors'
import View from '../../ui/forget-password/ForgetPassword'

const withSendInstructions = connect(
  state => ({
    isSending: isSendingIntructions(state)
  }),
  { createPasswordReset }
)

export const withEmailFormState = withStateHandlers(
  { email: '', isError: false, isSuccess: false, errorMessage: null },
  {
    setEmail: state => email => {
      return { email }
    },
    setOutcome: state => (isSuccess, errorMessage = '') => ({
      isSuccess: !!isSuccess,
      isError: !isSuccess,
      errorMessage: !isSuccess ? errorMessage : null
    })
  }
)

export const withUIHandlers = withHandlers({
  onSendInstructionsClick: props => e => {
    const { email, isSending, createPasswordReset, setOutcome } = props
    e.preventDefault()
    if (!isSending) {
      return createPasswordReset(email).then(outcome => {
        const { error, result } = outcome
        if (result) {
          return setOutcome(true)
        }
        if (error) {
          return setOutcome(false, error.message || 'error')
        }
      })
    }
  },
  onEmailChange: props => e => {
    const { setEmail } = props
    setEmail(e.target.value)
  }
})

export const decorator = compose(
  withEmailFormState,
  withSendInstructions,
  withUIHandlers
)

export default decorator(View)



// WEBPACK FOOTER //
// ./src/services/password-reset/ForgetPassword.js